import { useCallback, useState } from 'react';

const initialDefault = false;

const useToggle = (initial?: boolean) => {
  const [isOpen, setIsOpen] = useState<boolean>(initial ?? initialDefault);
  const set = useCallback((value: boolean) => setIsOpen(value), [setIsOpen]);
  const open = useCallback(() => setIsOpen(true), [setIsOpen]);
  const close = useCallback(() => setIsOpen(false), [setIsOpen]);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), [setIsOpen]);

  return {
    isOpen,
    set,
    open,
    close,
    toggle,
  };
};

export default useToggle;
